import React, { useContext, useState, useEffect } from 'react';
import { Button, Container, Nav, Navbar } from "react-bootstrap";
import { useNavigate, useLocation } from "react-router-dom";
import { ADMIN_ROUTE, LOGIN_ROUTE, BASKET_ROUTE, SHOP_ROUTE, STORE_INFO_ROUTE } from "../utils/consts";
import { observer } from "mobx-react-lite";
import { Context } from "../index";
import { FaShoppingCart, FaUser, FaSignOutAlt } from 'react-icons/fa';
import UserNotifications from './UserNotifications';

const NavBar = observer(() => {
    const { user } = useContext(Context);
    const cartCount = user.basket.reduce((sum, item) => sum + (item.quantity || 1), 0);
    const navigate = useNavigate();
    const location = useLocation();
    const [expanded, setExpanded] = useState(false);
    const [isMobile, setIsMobile] = useState(window.innerWidth <= 991);

    useEffect(() => {
        const handleResize = () => setIsMobile(window.innerWidth <= 991);
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    const logOut = () => {
        user.setUser({});
        user.setIsAuth(false);
        setExpanded(false);
        navigate(SHOP_ROUTE);
    }

    const isActive = (path) => {
        if (path === SHOP_ROUTE) {
            return location.pathname === path || location.pathname.startsWith('/shop');
        }
        return location.pathname === path;
    };

    return (
        <Navbar bg="light" expand="lg" className="navbar w-100 p-0" expanded={expanded} onToggle={setExpanded}>
            <Container>
                <Navbar.Brand 
                    onClick={() => { navigate(STORE_INFO_ROUTE); setExpanded(false); }}
                    className="navbar-brand"
                    tabIndex={0}
                    onKeyPress={(e) => e.key === 'Enter' && (navigate(STORE_INFO_ROUTE), setExpanded(false))}
                    aria-label="Перейти на главную страницу"
                >
                    Магазин Карусель
                </Navbar.Brand>
                {/* Mobile Action Buttons Group - only show when expanded */}
                {isMobile && user.isAuth && expanded && (
                  <div className="mobile-action-buttons">
                    {(user.user.role === 'main_admin' || user.user.role === 'store_admin') && (
                      <button className={`mobile-action-btn admin${location.pathname === ADMIN_ROUTE ? ' active' : ''}`} onClick={() => { navigate(ADMIN_ROUTE); setExpanded(false); }} aria-label="Админ">
                        <FaUser />
                        <span className="mobile-action-label">Админ</span>
                      </button>
                    )}
                    <button className={`mobile-action-btn profile${location.pathname === '/profile' ? ' active' : ''}`} onClick={() => { navigate('/profile'); setExpanded(false); }} aria-label="Личный кабинет">
                      <FaUser />
                      <span className="mobile-action-label mobile-action-label-center">Профиль</span>
                    </button>
                    <button className={`mobile-action-btn basket${location.pathname === BASKET_ROUTE ? ' active' : ''}`} onClick={() => { navigate(BASKET_ROUTE); setExpanded(false); }} aria-label="Корзина" style={{ position: 'relative' }}>
                      <FaShoppingCart />
                      {cartCount > 0 && (
                        <span className="notification-badge-mobile">{cartCount}</span>
                      )}
                      <span className="mobile-action-label mobile-action-label-center">Корзина</span>
                    </button>
                    <UserNotifications mobile />
                    <button className="mobile-action-btn logout" onClick={logOut} aria-label="Выйти">
                      <FaSignOutAlt />
                      <span className="mobile-action-label mobile-action-label-center">Выйти</span>
                    </button>
                  </div>
                )}
                {isMobile && !user.isAuth && expanded && (
                  <div className="mobile-action-buttons">
                    <button className="mobile-action-btn login" onClick={() => { navigate(LOGIN_ROUTE); setExpanded(false); }} aria-label="Войти">
                      <FaUser />
                      <span className="mobile-action-label mobile-action-label-center">Войти</span>
                    </button>
                  </div>
                )}
                <Navbar.Toggle aria-controls="basic-navbar-nav" />
                <Navbar.Collapse id="basic-navbar-nav">
                    {isMobile && !expanded ? null : (
                      <Nav className={isMobile ? "me-auto mobile-nav-btns" : "me-auto"}>
                        <Nav.Link 
                            onClick={() => { navigate('/'); setExpanded(false); }}
                            className={isMobile ? (isActive('/') ? 'active mobile-nav-btn' : 'mobile-nav-btn') : (isActive('/') ? 'active' : '')}
                            aria-current={isActive('/') ? 'page' : undefined}
                        >
                          <span className="mobile-nav-icon">🏠</span> Главная
                        </Nav.Link>
                        <Nav.Link 
                            onClick={() => { navigate('/shoes'); setExpanded(false); }}
                            className={isMobile ? (isActive(SHOP_ROUTE) && location.search.includes('type=shoe') ? 'active mobile-nav-btn' : 'mobile-nav-btn') : (isActive(SHOP_ROUTE) && location.search.includes('type=shoe') ? 'active' : '')}
                            aria-current={isActive(SHOP_ROUTE) && location.search.includes('type=shoe') ? 'page' : undefined}
                        >
                          <span className="mobile-nav-icon">👟</span> Обувь
                        </Nav.Link>
                        <Nav.Link 
                            onClick={() => { navigate('/shop?type=clothes'); setExpanded(false); }}
                            className={isMobile ? (isActive(SHOP_ROUTE) && location.search.includes('type=clothes') ? 'active mobile-nav-btn' : 'mobile-nav-btn') : (isActive(SHOP_ROUTE) && location.search.includes('type=clothes') ? 'active' : '')}
                            aria-current={isActive(SHOP_ROUTE) && location.search.includes('type=clothes') ? 'page' : undefined}
                        >
                          <span className="mobile-nav-icon">👕</span> Одежда
                        </Nav.Link>
                        <Nav.Link 
                            onClick={() => { navigate('/shop?type=toy'); setExpanded(false); }}
                            className={isMobile ? (isActive(SHOP_ROUTE) && location.search.includes('type=toy') ? 'active mobile-nav-btn' : 'mobile-nav-btn') : (isActive(SHOP_ROUTE) && location.search.includes('type=toy') ? 'active' : '')}
                            aria-current={isActive(SHOP_ROUTE) && location.search.includes('type=toy') ? 'page' : undefined}
                        >
                          <span className="mobile-nav-icon">🧸</span> Игрушки
                        </Nav.Link>
                        <Nav.Link 
                            onClick={() => { navigate('/shop'); setExpanded(false); }}
                            className={isMobile ? (isActive(SHOP_ROUTE) && !location.search ? 'active mobile-nav-btn' : 'mobile-nav-btn') : (isActive(SHOP_ROUTE) && !location.search ? 'active' : '')}
                            aria-current={isActive(SHOP_ROUTE) && !location.search ? 'page' : undefined}
                        >
                          <span className="mobile-nav-icon">🛒</span> Все товары
                        </Nav.Link>
                    </Nav>
                    )}
                    {/* Desktop user actions remain as before */}
                    {!isMobile && (
                    <Nav className="ms-auto d-flex align-items-center">
                        {user.isAuth ? (
                            <>
                                {(user.user.role === 'main_admin' || user.user.role === 'store_admin') && (
                                    <Nav.Link 
                                        onClick={() => { navigate(ADMIN_ROUTE); setExpanded(false); }}
                                        className={isActive(ADMIN_ROUTE) ? 'active' : ''}
                                        aria-current={isActive(ADMIN_ROUTE) ? 'page' : undefined}
                                    >
                                        <FaUser className="me-1" />
                                        Админ-панель
                                    </Nav.Link>
                                )}
                                <Nav.Link 
                                    onClick={() => { navigate('/profile'); setExpanded(false); }}
                                    className={isActive('/profile') ? 'active' : ''}
                                    aria-current={isActive('/profile') ? 'page' : undefined}
                                >
                                    <FaUser className="me-1" />
                                    Личный кабинет
                                </Nav.Link>
                                <Nav.Link 
                                    onClick={() => { navigate(BASKET_ROUTE); setExpanded(false); }}
                                    className={isActive(BASKET_ROUTE) ? 'active' : ''}
                                    aria-current={isActive(BASKET_ROUTE) ? 'page' : undefined}
                                    style={{ position: 'relative', display: 'inline-flex', alignItems: 'center' }}
                                >
                                    <FaShoppingCart className="me-1" />
                                    {cartCount > 0 && (
                                      <span className="cart-badge-desktop">{cartCount}</span>
                                    )}
                                    Корзина
                                </Nav.Link>
                                <Button 
                                    variant="link" 
                                    className="nav-link text-danger" 
                                    onClick={logOut}
                                    aria-label="Выйти из системы"
                                >
                                    <FaSignOutAlt className="me-1" />
                                    Выйти
                                </Button>
                                <div className="ms-2">
                                    <UserNotifications />
                                </div>
                            </>
                        ) : (
                            <Nav.Link 
                                onClick={() => { navigate(LOGIN_ROUTE); setExpanded(false); }}
                                className={isActive(LOGIN_ROUTE) ? 'active' : ''}
                                aria-current={isActive(LOGIN_ROUTE) ? 'page' : undefined}
                            >
                                <FaUser className="me-1" />
                                Войти
                            </Nav.Link>
                        )}
                    </Nav>
                    )}
                </Navbar.Collapse>
            </Container>
        </Navbar>
    );
});

export default NavBar;